import React, { useContext, useEffect, useState, Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { AuthProvider, AuthContext } from "./utils/AuthContext";
import { showAlert } from "./utils/Alerts";
const Backend = lazy(() => import("./backend"));
const ViewApplication = lazy(() => import("./backend/employee/services/Property/View/ViewApplication.js"));
const ValidateUser = lazy(() => import("./utils/userAuth"));
const LandingPage = lazy(() => import("./landingPage"));
const UserManual = lazy(() => import("./landingPage/pages/HomeMenus/UserManual.js"));
const SOP = lazy(() => import("./landingPage/pages/HomeMenus/SOP.js"));
const RtiDocument = lazy(() => import("./landingPage/pages/HomeMenus/RtiDocuments.js"));
const Faq = lazy(() => import("./landingPage/pages/HomeMenus/Faq.js"));
const ContactUs = lazy(() => import("./landingPage/pages/HomeMenus/ContactUs.js"));
const QuickBillPayment = lazy(() => import("./landingPage/pages/BillPayment/QuickBillPayment.jsx"));
const NotificationOrder = lazy(() => import("./landingPage/pages/HomeMenus/NotificationOrder.js"));
const Introduction = lazy(() => import("./landingPage/pages/HomeMenus/Introduction.js"));
const OrganizationChart = lazy(() => import("./landingPage/pages/HomeMenus/OrganizationChart.js"));
const WebistePolicy = lazy(() => import("./landingPage/pages/websitePolicy.js"));
const PrivacyPolicy = lazy(() => import("./landingPage/pages/PrivacyPolicy.jsx"));
const CitizenPendingPayments = lazy(() => import("./landingPage/pages/CitizenPendingPayments.js"));
const CitizenGrievances = lazy(() => import("./landingPage/pages/CitizenGrievances"));
const CitizenGrievance = lazy(() => import("./landingPage/pages/CitizenGrievances/ViewGrievance.js"));
const CitizenGrievancesList = lazy(() => import("./landingPage/pages/CitizenGrievances/GrievancesList.js"));
const SamadhanShivir = lazy(() => import("./landingPage/pages/SamadhanShivir"));
const SamadhanShivirView = lazy(() => import("./landingPage/pages/SamadhanShivir/ViewGrievance.js"));
const SamadhanShivirList = lazy(() => import("./landingPage/pages/SamadhanShivir/GrievancesList.js"));
const GrievancesList = lazy(() => import("./backend/employee/services/grievances"));
const GrievancesView = lazy(() => import("./backend/employee/services/grievances/GrievanceView.js"));
const Acts = lazy(() => import("./landingPage/pages/HomeMenus/Acts.js"));
const Rules = lazy(() => import("./landingPage/pages/HomeMenus/Rules.js"));
// const UserLogout = lazy(() => import("./UserProfile"));
const EmployeeLogin = lazy(() => import("./employee/EmployeeLogin"));
const ForgotPassword = lazy(() => import("./employee/ForgotPassword"));
const NewTradeRegistration = lazy(() => import("./backend/services/tradeLicense/registration"));
const TradeLicenseRenewal = lazy(() => import("./backend/services/tradeLicense/renewal"));
const TradeLicenseClosure = lazy(() => import("./backend/services/tradeLicense/closure"));
const TradeLicenseModification = lazy(() => import("./backend/services/tradeLicense/modification"));
const ViewTradeApplication = lazy(() => import("./backend/services/tradeLicense/registration/ViewApplication.js"));
const TradeLicenseDashboard = lazy(() => import("./backend/dashboard/tradeLicenseDashboard.js"));
const ApplicationView = lazy(() => import("./backend/employee/applicationViews/index.js"));
const CitizenPayment = lazy(() => import("./backend/services/payments"));
const LmkPayment = lazy(() => import("./backend/services/lmkPayments"));
const GarbageRegistration = lazy(() => import("./backend/services/garbageCollection/registration/index.js"));
const GarbageDashboard = lazy(() => import("./backend/dashboard/garbageDashboard.js"));
const GarbageList = lazy(() => import("./backend/services/garbageCollection/billing/index.js"));
const ViewGarbageApplication = lazy(() => import("./backend/services/garbageCollection/registration/ViewApplication.js"));
const NewPetRegistration = lazy(() => import("./backend/services/pets/registration"));
const PetDashboard = lazy(() => import("./backend/dashboard/petDashboard.js"));
const ViewPetApplication = lazy(() => import("./backend/services/pets/registration/ViewApplication.js"));
const PetRenewal = lazy(() => import("./backend/services/pets/registration/PetRenewal.js"));
const TradeRenewalFee = lazy(() => import("./backend/employee/services/master/tradeLicense/tradeRenewalFee.js"));
const NewSiteRegistration = lazy(() => import("./backend/employee/services/advertisement/registration"));
const SiteDashboard = lazy(() => import("./backend/dashboard/siteDashboard.js"));
const AssetDashboard = lazy(() => import("./backend/dashboard/assetDashboard.js"));
const ViewSite = lazy(() => import("./backend/employee/services/advertisement/registration/ViewSite.js"));
const ViewAsset = lazy(() => import("./backend/employee/services/asset/registration/ViewAsset.js"));
const BookSite = lazy(() => import("./backend/services/advertisement/booking"));
const SiteBookingDashboard = lazy(() => import("./backend/dashboard/siteBookingDashboard.js"));
const NewAssetRegistration = lazy(() => import("./backend/employee/services/asset/registration"));
const MasterAsset = lazy(() => import("./backend/employee/services/asset/registration/AssetMaster.js"));
const AssetBooking = lazy(() => import("./backend/services/asset/booking"));
const AssetBookingDashboard = lazy(() => import("./backend/dashboard/assetBookingDashboard.js"));
const ViewSiteBooking = lazy(() => import("./backend/services/advertisement/booking/ViewSiteBooking.js"));
const ViewAssetBooking = lazy(() => import("./backend/services/asset/booking/ViewAssetBooking.js"));
const Loader1 = lazy(() => import("./components/Loader.js"));
const Loader = lazy(() => import("./utils/Loader/ApiLoader.jsx"));
const Factor1 = lazy(() => import("./backend/employee/services/master/Factor1/index.js"));
const Factor2 = lazy(() => import("./backend/employee/services/master/Factor2/index.js"));
const Factor3 = lazy(() => import("./backend/employee/services/master/Factor3/index.js"));
const Factor4 = lazy(() => import("./backend/employee/services/master/Factor4/index.js"));
const Factor5 = lazy(() => import("./backend/employee/services/master/Factor5/index.js"));
const Penality = lazy(() => import("./backend/employee/services/master/Penality/index.js"));
const Overall = lazy(() => import("./backend/employee/services/master/Overall/index.js"));
const RebateMaster = lazy(() => import("./backend/employee/services/master/garbageRebateMaster/index.js"));
const PenaltyMaster = lazy(() => import("./backend/employee/services/master/garbagePenaltyMaster/index.js"));
const EarlyPayment = lazy(() => import("./backend/employee/services/master/EarlyPayment/index.js"));
const PropertyTaxLandRate = lazy(() => import("./backend/employee/services/master/PropertyTaxCal/PropertyLandRate.js"));
const PropertyTaxCal = lazy(() => import("./backend/employee/services/master/PropertyTaxCal/index.js"));
const PropertyRegistrationIndex = lazy(() => import("./backend/employee/propertyTax/PropertyRegistration"));
const PropertyRegistrationView = lazy(() => import("./backend/employee/propertyTax/PropertyRegistration/view.js"));
const BillGeneration = lazy(() => import("./backend/employee/propertyTax/PropertyRegistration/bill.js"));
const Area = lazy(() => import("./backend/employee/services/master/Area/index.js"));
const Purpose = lazy(() => import("./backend/employee/services/master/Purpose/index.js"));
const ConstructionYear = lazy(() => import("./backend/employee/services/master/ConstructionYear/index.js"));
const InterestRate = lazy(() => import("./backend/employee/services/master/InterestRate/index.js"));
const UseOfBuilding = lazy(() => import("./backend/employee/services/master/UseOfBuilding/index.js"));
const RedirectToNew = lazy(() => import("./components/RedirectToNew.jsx"));
const ChangePassword = lazy(() => import("./backend/employee/changePassword.js"));
const EgovFinance = lazy(() => import("./rainmaker/employee/Erp/index.js"));
const SupersetDashboard = lazy(() => import("./Dashboards/index.js"));
const MetabaseDashboard = lazy(() => import("./Dashboards/meta.js"));
const UserIdle = lazy(() => import("./components/UserIdle.js"));


const Sevabandhu = lazy(() => import("./landingPage/pages/HomeMenus/SevaBandhu.js"));
const PaymentReceipt = lazy(() => import("./backend/print/PaymentReceipt"));
const ObpassRequestValidator = lazy(() => import("./backend/obpass/ObpassRequestValidator.js"));
const PetRenewalFee = lazy(() => import("./backend/employee/services/master/Pet/PetRenewalFee.js"));
const Dmc = lazy(() => import("./landingPage/pages/Dmc.js"));
const UtilityServiceIndex = lazy(() => import("./landingPage/pages/HomeMenus/SevaBandhu/UtilityServiceIndex.jsx"));
const LmkLogin = lazy(() => import("./landingPage/pages/HomeMenus/LmkLogin.js"));

const PayInstruction = lazy(() => import("./landingPage/pages/PayInstruction.jsx"));

const PrivateRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);
  const [showingAlert, setShowingAlert] = useState(false);
  const [redirect, setRedirect] = useState(false);
  useEffect(() => {
    if (!loading && !user && !showingAlert) {
      showAlert(
        "Unauthorized",
        "You must be logged in to access this page",
        "warning"
      );
      setShowingAlert(true);
      setRedirect(true);
    }
  }, [loading, user, showingAlert]);

  if (loading) return <Loader />;
  if (redirect) return <Navigate to="/" />;
  return <UserIdle>{children}</UserIdle>;
};
const AuthCheck = ({ children }) => {
  const { user, loading, logout } = useContext(AuthContext);
  const [showingAlert, setShowingAlert] = useState(false);
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    if (user) {
      //logout();
    }
  }, [loading, user]);

  if (loading) return <Loader />;
  if (redirect) return <Navigate to="/" />;
  return user ? <UserIdle>{children}</UserIdle> : children;
};
function App() {
  return (
    <>
      <AuthProvider>
        <Router basename={process.env.REACT_APP_BASE_PATH}>
          <Suspense fallback={<Loader />}>
            <Routes>
              <Route
                path="/"
                element={
                  <AuthCheck>
                    <LandingPage />
                  </AuthCheck>
                }
              />
              <Route
                path="/user-manual"
                element={
                  <AuthCheck>
                    <UserManual />
                  </AuthCheck>
                }
              />
              <Route
                path="/sop-manual"
                element={
                  <AuthCheck>
                    <SOP />{" "}
                  </AuthCheck>
                }
              />
              <Route
                path="/rti-documents"
                element={
                  <AuthCheck>
                    <RtiDocument />
                  </AuthCheck>
                }
              />
              <Route
                path="/faq"
                element={
                  <AuthCheck>
                    <Faq />
                  </AuthCheck>
                }
              />
              <Route
                path="/contact-us"
                element={
                  <AuthCheck>
                    <ContactUs />
                  </AuthCheck>
                }
              />
              <Route
                path="/lmk-login"
                element={
                  <AuthCheck>
                    <LmkLogin />
                  </AuthCheck>
                }
              />
              <Route path="/bill-payment/quick-bill-payment/:billType" element={<QuickBillPayment />} />
              <Route
                path="/notification-order"
                element={
                  <AuthCheck>
                    <NotificationOrder />
                  </AuthCheck>
                }
              />
              <Route
                path="/seva-bandhu"
                element={
                  <AuthCheck>
                    <Sevabandhu />
                  </AuthCheck>
                }
              />
              <Route
                path="/introduction"
                element={
                  <AuthCheck>
                    <Introduction />
                  </AuthCheck>
                }
              />
              <Route
                path="/organization-chart"
                element={
                  <AuthCheck>
                    <OrganizationChart />
                  </AuthCheck>
                }
              />
              <Route
                path="/webiste-policy"
                element={
                  <AuthCheck>
                    <WebistePolicy />{" "}
                  </AuthCheck>
                }
              />
              <Route
                path="/privacy-policy"
                element={
                  <AuthCheck>
                    <PrivacyPolicy/>
                  </AuthCheck>
                }
              />
              <Route
                path="/payment-instructions"
                element={
                  <AuthCheck>
                    <PayInstruction />
                  </AuthCheck>
                }
              />
              <Route
                path="/citizen-payment/:uuid/:gid?/:pid?"
                element={<CitizenPendingPayments />}
              />
              <Route
                path="/citizen-grievances"
                element={
                  <AuthCheck>
                    <CitizenGrievances />{" "}
                  </AuthCheck>
                }
              />
              <Route
                path="/citizen-grievance"
                element={
                  <AuthCheck>
                    <CitizenGrievance />{" "}
                  </AuthCheck>
                }
              />
              <Route
                path="/citizen-grievances-list"
                element={
                  <AuthCheck>
                    <CitizenGrievancesList />{" "}
                  </AuthCheck>
                }
              />
              <Route
                path="/backend/grievances-list"
                element={
                  <PrivateRoute>
                    <GrievancesList />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/grievance-view"
                element={
                  <PrivateRoute>
                    <GrievancesView />
                  </PrivateRoute>
                }
              />
              <Route
                path="/citizen-samadhan"
                element={
                  <AuthCheck>
                    <SamadhanShivir />{" "}
                  </AuthCheck>
                }
              />
              <Route
                path="/citizen-samadhan-view"
                element={
                  <AuthCheck>
                    <SamadhanShivirView />{" "}
                  </AuthCheck>
                }
              />

              <Route
                path="/citizen-samadhan-list"
                element={
                  <AuthCheck>
                    <SamadhanShivirList />{" "}
                  </AuthCheck>
                }
              />
              <Route
                path="/validate-user"
                element={
                  <AuthCheck>
                    <ValidateUser />
                  </AuthCheck>
                }
              />
              <Route
                path="/validate-user-obpas"
                element={
                  <AuthCheck>
                    <ValidateUser />
                  </AuthCheck>
                }
              />
              <Route
                path="/dashboards"
                element={
                  <AuthCheck>
                    <SupersetDashboard />
                  </AuthCheck>
                }
              />
               <Route
                path="/meta-dashboard"
                element={
                  <AuthCheck>
                    <MetabaseDashboard />
                  </AuthCheck>
                }
              />
              <Route
                path="/employee-login"
                element={
                  <AuthCheck>
                    <EmployeeLogin />
                  </AuthCheck>
                }
              />
              <Route
                path="/forgot-password"
                element={
                  <AuthCheck>
                    <ForgotPassword />
                  </AuthCheck>
                }
              />
              <Route path="/acts-rules" element={<AuthCheck><Acts /></AuthCheck>} />
              <Route path="/byelaws" element={<AuthCheck><Rules /></AuthCheck>} />
              <Route
                path="/backend"
                element={
                  <PrivateRoute>
                    <Backend />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/new-trade-registration"
                element={
                  <PrivateRoute>
                    <NewTradeRegistration />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/trade-license-renewal"
                element={
                  <PrivateRoute>
                    <TradeLicenseRenewal />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/trade-license-closure"
                element={
                  <PrivateRoute>
                    <TradeLicenseClosure />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/trade-license-modification"
                element={
                  <PrivateRoute>
                    <TradeLicenseModification />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/view-trade-application"
                element={
                  <PrivateRoute>
                    <ViewTradeApplication />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/trade-license-dashboard"
                element={
                  <PrivateRoute>
                    <TradeLicenseDashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/citizen-payments"
                element={
                  <PrivateRoute>
                    <CitizenPayment />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/lmk-payments"
                element={
                  <PrivateRoute>
                    <LmkPayment />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/employee/view-application"
                element={
                  <PrivateRoute>
                    <ApplicationView />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/new-garbage-registration"
                element={
                  <PrivateRoute>
                    <GarbageRegistration />
                  </PrivateRoute>
                }
              />
              {/* <Route
								path="/backend/garbage-account-closure"
								element={
									<PrivateRoute>
										<GarbageAccountClosure />
									</PrivateRoute>
								}
							/>
							<Route
								path="/backend/garbage-account-modification"
								element={
									<PrivateRoute>
										<GarbageAccountModification />
									</PrivateRoute>
								}
							/> */}
              <Route
                path="/backend/garbage-dashboard"
                element={
                  <PrivateRoute>
                    <GarbageDashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/view-garbage-application"
                element={
                  <PrivateRoute>
                    <ViewGarbageApplication />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/garbage-bills"
                element={
                  <PrivateRoute>
                    <GarbageList />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/garbage-master-rebate"
                element={
                  <PrivateRoute>
                    <RebateMaster />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/garbage-master-penalty"
                element={
                  <PrivateRoute>
                    <PenaltyMaster />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/new-pet-registration"
                element={
                  <PrivateRoute>
                    <NewPetRegistration />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/pet-dashboard"
                element={
                  <PrivateRoute>
                    <PetDashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/view-pet-application"
                element={
                  <PrivateRoute>
                    <ViewPetApplication />
                  </PrivateRoute>
                }
              />
              {/* Pet Renewal */}
              <Route
                path="backend/pet-renewal"
                element={<PrivateRoute><PetRenewal /></PrivateRoute>}
              />
              <Route
                path="/backend/new-site-registration"
                element={
                  <PrivateRoute>
                    <NewSiteRegistration />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/new-asset-registration"
                element={
                  <PrivateRoute>
                    <NewAssetRegistration />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/master-asset"
                element={
                  <PrivateRoute>
                    <MasterAsset />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/site-dashboard"
                element={
                  <PrivateRoute>
                    <SiteDashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/asset-dashboard"
                element={
                  <PrivateRoute>
                    <AssetDashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/view-site"
                element={
                  <PrivateRoute>
                    <ViewSite />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/view-asset"
                element={
                  <PrivateRoute>
                    <ViewAsset />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/book-site"
                element={
                  <PrivateRoute>
                    <BookSite />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/site-booking-dashboard"
                element={
                  <PrivateRoute>
                    <SiteBookingDashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/view-site-booking"
                element={
                  <PrivateRoute>
                    <ViewSiteBooking />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/book-asset"
                element={
                  <PrivateRoute>
                    <AssetBooking />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/asset-booking-dashboard"
                element={
                  <PrivateRoute>
                    <AssetBookingDashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/view-asset-booking"
                element={
                  <PrivateRoute>
                    <ViewAssetBooking />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/factor1"
                element={
                  <PrivateRoute>
                    <Factor1 />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/factor2"
                element={
                  <PrivateRoute>
                    <Factor2 />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/factor3"
                element={
                  <PrivateRoute>
                    <Factor3 />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/factor4"
                element={
                  <PrivateRoute>
                    <Factor4 />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/factor5"
                element={
                  <PrivateRoute>
                    <Factor5 />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/penality"
                element={
                  <PrivateRoute>
                    <Penality />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/overall-rebate"
                element={
                  <PrivateRoute>
                    <Overall />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/early-payment-rebate"
                element={
                  <PrivateRoute>
                    <EarlyPayment />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/property-calculation-land-rate"
                element={
                  <PrivateRoute>
                    <PropertyTaxLandRate />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/property-calculation-tax"
                element={
                  <PrivateRoute>
                    <PropertyTaxCal />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/property-bills"
                element={
                  <PrivateRoute>
                    <BillGeneration />
                  </PrivateRoute>
                }
              />

              <Route
                path="/backend/area"
                element={
                  <PrivateRoute>
                    <Area />
                  </PrivateRoute>
                }
              />

              <Route
                path="/backend/purpose-use"
                element={
                  <PrivateRoute>
                    <Purpose />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/Construction-Year"
                element={
                  <PrivateRoute>
                    <ConstructionYear />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/interest-Rate"
                element={
                  <PrivateRoute>
                    <InterestRate />
                  </PrivateRoute>
                }
              />

              <Route
                path="/backend/building-use"
                element={
                  <PrivateRoute>
                    <UseOfBuilding />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/property-registration"
                element={
                  <PrivateRoute>
                    <PropertyRegistrationIndex />
                  </PrivateRoute>
                }
              />

              <Route
                path="/backend/property-view"
                element={
                  <PrivateRoute>
                    <PropertyRegistrationView />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/property-bill"
                element={
                  <PrivateRoute>
                    <BillGeneration />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/redirect-to-new"
                element={
                  <PrivateRoute>
                    <RedirectToNew />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/change-password"
                element={
                  <PrivateRoute>
                    <ChangePassword />
                  </PrivateRoute>
                }
              />
              <Route
                path="/egov-finance"
                element={
                  <PrivateRoute>
                    <EgovFinance />
                  </PrivateRoute>
                }
              />
              <Route
                path="/print/receipt"
                element={
                  <PrivateRoute>
                    <PaymentReceipt />
                  </PrivateRoute>
                }
              />
              <Route
                path="/validate-user/obpass-request"
                element={
                  <ObpassRequestValidator />
                }
              />
              <Route
                path="/backend/pet-renewal-fee"
                element={
                  <PrivateRoute>
                    <PetRenewalFee />
                  </PrivateRoute>
                }
              />
              <Route
                path="/backend/trade-renewal-fee"
                element={
                  <PrivateRoute>
                    <TradeRenewalFee />
                  </PrivateRoute>
                }
              />
              <Route
                path="/dmc"
                element={
                  <AuthCheck>
                    <Dmc />
                  </AuthCheck>
                }
              />
              <Route
                path="/backend/utility-service-dashboard"
                element={
                  <AuthCheck>
                    <UtilityServiceIndex />
                  </AuthCheck>
                }
              />
            </Routes>
          </Suspense>
        </Router>
      </AuthProvider>
    </>
  );
}
export default App;
